import { useMemo, useRef, useState } from 'react'
import { DeleteServiceCategory, GetserviceCatgory } from '@/api/endpoints'
import BaseBtn from '@/components/tableDrawer/TableItems/components/tableActions/BaseBtn'
import { ReportContent, ReportHeader, ReportSearch } from '@/components/tableDrawer'
import ScreenHeader from '@/components/ScreenHeader'
import ActionBtn from '@/components/ActionBtn'
import CUServiceCategory from './CUServiceCategory'
import DeleteBtn from '@/components/tableDrawer/TableItems/components/tableActions/DeleteBtn'
import { ColumnsGenerator } from '@/utils/tableUtils'

const ServiceCategories = () => {


    const serviceCatgoryModel = useRef(null)
    const updateModal = useRef(null)
    
    const [recordID, setRecordID] = useState(null)

    const columns = useMemo(() => [
        ColumnsGenerator.SearchableTextCell('name' ,'service-category-name' , 'name'),
        ColumnsGenerator.SearchableTextCell('nameEN','service-category-name-en' , 'nameEN'),
        ColumnsGenerator.TextCell('type','service-category-type'),
        {
            Header: 'action',
            id: 'action',
            Cell: ({ row }) => (
                <>
                    <DeleteBtn id={row.original.id} api={DeleteServiceCategory} />
                    <BaseBtn onApply={() => handleAddServiceCategory(row.original.id)} title="edit-service-category" className="details-info" reqAction="canGet" icon={"fluent:eye-16-filled"} />
                </>
            ),
        }], [])


    const handleAddServiceCategory = (id) => {
        updateModal.current.click()
        setRecordID(id)
    }
    return (
        <>
            <ScreenHeader title="service-categories">
                <ActionBtn onApply={() => serviceCatgoryModel.current.click()} title="add-service-category" className="accept-btn" icon={"mdi:plus"} />
            </ScreenHeader>

            <ReportContent tableAPI={GetserviceCatgory} columns={columns}>
                <ReportHeader>
                    <ReportSearch />
                </ReportHeader>
            </ReportContent>

            <CUServiceCategory modalID={serviceCatgoryModel} />
            <CUServiceCategory RecordID={recordID} modalID={updateModal} />

        </>
    )
}

export default ServiceCategories